import React from 'react';
import PropTypes from 'prop-types';
import { Checkbox, FormControlLabel } from '@mui/material';

const CustomCheckbox = ({ checked, onToggle, label, size, disabled, labelSx, checkboxProps, formControlLabelProps, dataTestId }) => {
    const handleChange = (e) => {
        const isChecked = !!e.target.checked;
        if (typeof onToggle === 'function') onToggle(isChecked);
    };

    return (
        <FormControlLabel
            control={<Checkbox size={size} checked={!!checked} onChange={handleChange} disabled={disabled} {...checkboxProps} />}
            label={label}
            sx={labelSx}
            data-testid={dataTestId}
            {...formControlLabelProps}
        />
    );
};

CustomCheckbox.propTypes = {
    checked: PropTypes.bool.isRequired,
    onToggle: PropTypes.func.isRequired,
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    size: PropTypes.oneOf(['small', 'medium']),
    disabled: PropTypes.bool,
    labelSx: PropTypes.object,
    checkboxProps: PropTypes.object,
    formControlLabelProps: PropTypes.object,
    dataTestId: PropTypes.string,
};

CustomCheckbox.defaultProps = {
    label: '',
    size: 'small',
    disabled: false,
    labelSx: {},
    checkboxProps: {},
    formControlLabelProps: {},
    dataTestId: 'custom-checkbox',
};

export default CustomCheckbox;
